import { render, staticRenderFns } from "./FlyerThumbList.vue?vue&type=template&id=0b018ab4&scoped=true&"
import script from "./FlyerThumbList.vue?vue&type=script&lang=js&"
export * from "./FlyerThumbList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b018ab4",
  null
  
)

export default component.exports